import { Box } from '@mui/material';
import { Button  } from '../../../../shared/components/ui/Button';

interface RoomFormActionsProps {
  isSubmitting: boolean;
  onBack: () => void;
  mode: 'create' | 'edit';
}

export function RoomFormActions({ isSubmitting, onBack, mode }: RoomFormActionsProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
      <Button
        variant="outlined"
        onClick={onBack}
        disabled={isSubmitting}
      >
        ← Voltar
      </Button>
      <Button
        variant="contained"
        type="submit"
        loading={isSubmitting}
        disabled={isSubmitting}
      >
        ✓ {mode === 'create' ? 'Criar Sala' : 'Salvar Alterações'}
      </Button>
    </Box>
  );
} 